/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class Address {
    street: string; // ecf001
    houseNumber: string; // ecf001
    //postIndex: string; => Not being used anymore with the introduction of the BestAddresses
    postcode: string;
    postalCode: string; // ecf001
    city: string; // ecf001
    extra: string;
    bestAddressStreetId: string;
    bestAddressId: string;
    country: string;

    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Address {
        if (!data) { return instance; }
        if (data.street != null) {instance.street = data.street; }
        if (data.houseNumber != null) {instance.houseNumber = data.houseNumber; }
        if (data.postalCode != null) {instance.postalCode = data.postalCode; }
        if (data.city != null) {instance.city = data.city; }
        if (data.country != null) {instance.country = data.country; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Address.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Address) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Address.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Address): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
